import axios from 'axios'

export const getFrame = async () => {
    const url = "https://orig.vphoto.mindlabs.cl/video_frame"
    const token = localStorage.getItem('x-auth-token');
    const headers = {
        'Content-Type': 'application/json',
        'x-auth-token': token,
    }
    try {
        const response = await axios.get(url, { headers: headers })
        console.warn(response);
        return response.data // Suponiendo que la respuesta tenga un campo `data` con los datos de usuario
    } catch (error) {
        console.log(error);
    }
}